import { render } from "./index.vue?vue&type=template&id=4550b36d&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=4550b36d&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-4550b36d"

export default script